import { render } from "./Contact.vue?vue&type=template&id=668112f7&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=668112f7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668112f7"]])

export default __exports__